

export default function ($hamburger, sections) {
  const hamburgerHeight = $hamburger.offset().top + $hamburger.outerHeight(true);

  let cur = sections.map(function () {
    let sectionTop = $(this).offset().top;
    if (hamburgerHeight > sectionTop)
      return this;
  });

  cur = cur[cur.length - 1];


  if (cur) {
    let hamburgerClass = $(cur).attr('data-hamburger');
    if (!$('.navigation-outer').hasClass(hamburgerClass)) {
      $('.navigation-outer').removeClass('hamburger-blue');
      $('.navigation-outer').removeClass('hamburger-wh');
      $('.navigation-outer').addClass(hamburgerClass);
    }
  }
}
